import { TASKS_GRID_TASK_CATEGORY_STORAGE_KEY } from 'constants/uiConstants';
import { InputTaskCategory } from 'interfaces/IInputTask';

/** The Tasks grid's Plan / Actual choice saved for this browser session (OP-2556); Plan when none. */
export const loadTaskCategory = (): InputTaskCategory => {
  try {
    return sessionStorage.getItem(TASKS_GRID_TASK_CATEGORY_STORAGE_KEY) ===
      String(InputTaskCategory.Actual)
      ? InputTaskCategory.Actual
      : InputTaskCategory.Plan;
  } catch {
    // Storage unavailable — Plan.
    return InputTaskCategory.Plan;
  }
};

export const saveTaskCategory = (category: InputTaskCategory) => {
  try {
    sessionStorage.setItem(
      TASKS_GRID_TASK_CATEGORY_STORAGE_KEY,
      String(category)
    );
  } catch {
    // Storage unavailable — the choice still applies for this visit.
  }
};
